import { render, staticRenderFns } from "./Scene9.vue?vue&type=template&id=1bb33758&scoped=true"
import script from "./Scene9.vue?vue&type=script&lang=js"
export * from "./Scene9.vue?vue&type=script&lang=js"
import style0 from "./Scene9.vue?vue&type=style&index=0&id=1bb33758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb33758",
  null
  
)

export default component.exports